import { render, staticRenderFns } from "./DataAccessLayout.vue?vue&type=template&id=c627ef02&scoped=true&"
import script from "./DataAccessLayout.vue?vue&type=script&lang=js&"
export * from "./DataAccessLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessLayout.vue?vue&type=style&index=0&id=c627ef02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c627ef02",
  null
  
)

export default component.exports